// NotFound.jsx
import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const NotFound = () => {
	return (
		<div style={{ textAlign: "center", padding: "100px 20px" }}>
			<Container>
				<Row className="g-3 justify-content-center">
					<h1 style={{color: "#00b2ff"}}>404</h1>
					<h2 style={{color: "red"}}>Oops! Page not found.</h2>
					<p>The page you’re looking for doesn’t exist.</p>
					<Link
                    className="w-auto text-center"
						to="/"
						style={{
							color: "white",
							backgroundColor: "#00b2ff",
							padding: "10px 20px",
							textDecoration: "none",
							borderRadius: "5px",
						}}
					>
						Go back to Home
					</Link>
				</Row>
			</Container>
		</div>
	);
};

export default NotFound;
